import Fontstyles from 'styles/Fonts.module.scss';
import PropTypes from 'prop-types';
import styles from 'styles/Box.module.scss';
import Text from 'core/text';

const Box = ({ title = null, subtitle = null, text = null }) => {
    return (
        <div className={styles.box}>
            <div className={styles.title}>
                <h2 className={Fontstyles.text_header3}>{ title }</h2>
                <h3 className={Fontstyles.text_header3}>{ subtitle }</h3>
            </div>
            {
                text && <Text content={text} />
            }
        </div>
    );
};

Box.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    text: PropTypes.string
};

export default Box;
